export const SOLO_CONFIRM_FILES_INVALIDATE = "SOLO_CONFIRM_FILES_INVALIDATE";
export const SOLO_CONFIRM_FILES_FETCH_REQUEST =
  "SOLO_CONFIRM_FILES_FETCH_REQUEST";
export const SOLO_CONFIRM_FILES_FETCH_SUCCESS =
  "SOLO_CONFIRM_FILES_FETCH_SUCCESS";
export const SOLO_CONFIRM_FILES_FETCH_ERROR = "SOLO_CONFIRM_FILES_FETCH_ERROR";
export const SOLO_ADD_FILE_TO_CONFIRM = "SOLO_ADD_FILE_TO_CONFIRM";
export const SOLO_REMOVE_FILE_TO_CONFIRM = "SOLO_REMOVE_FILE_TO_CONFIRM";
export const SOLO_ADD_FILE_TO_RECALL = "SOLO_ADD_FILE_TO_RECALL";
export const SOLO_REMOVE_FILE_TO_RECALL = "SOLO_REMOVE_FILE_TO_RECALL";
export const SOLO_CONFIRM_CASTS_FETCH_REQUEST =
  "SOLO_CONFIRM_CASTS_FETCH_REQUEST";
export const SOLO_CONFIRM_CASTS_FETCH_SUCCESS =
  "SOLO_CONFIRM_CASTS_FETCH_SUCCESS";
export const SOLO_CONFIRM_CASTS_FETCH_ERROR = "SOLO_CONFIRM_CASTS_FETCH_ERROR";
export const SOLO_RECALL_FILES_REQUEST = "SOLO_RECALL_FILES_REQUEST";
export const SOLO_RECALL_FILES_SUCCESS = "SOLO_RECALL_FILES_SUCCESS";
export const SOLO_RECALL_FILES_ERROR = "SOLO_RECALL_FILES_ERROR";

export const SIGN_OUT_COMPLETE = "SIGN_OUT_COMPLETE";
export { WORKAREA_SET } from "features/workarea/constants";
export { ORGANIZATION_SET } from "features/organization/constants";

export const SET_SOLO_CONFIRM_START_DATE_FILTER =
  "SET_SOLO_CONFIRM_START_DATE_FILTER";
export const SET_SOLO_CONFIRM_END_DATE_FILTER =
  "SET_SOLO_CONFIRM_END_DATE_FILTER";
export const SET_SOLO_CONFIRM_INSTRUMENT_NUMBER_FILTER =
  "SET_SOLO_CONFIRM_INSTRUMENT_NUMBER_FILTER";
export const SOLO_CLEAR_FILTERS = "SOLO_CLEAR_FILTERS";
export const UPDATE_SOLO_FILTERS = "UPDATE_SOLO_FILTERS";
